function initPriceRangeSlider() {
  const sliders = document.querySelectorAll('#price-slider-track');
  if (!sliders.length) return;

  function clean(str) {
    return parseFloat(String(str).replace(/[^0-9.]/g, ''));
  }

  function fmt(n, sym) {
    return sym + Number(n).toLocaleString();
  }

  sliders.forEach((slider) => {
    const wrap = slider.closest('.price-filter__wrap');
    const SYM = wrap?.dataset.currencySymbol || '';

    const display = wrap.querySelector('#pr-display');

    function getInputs() {
      return {
        min: slider.querySelector('input:first-of-type'),
        max: slider.querySelector('input:last-of-type'),
      };
    }

    const { min: minInput, max: maxInput } = getInputs();
    if (!minInput || !maxInput) return;

    const MIN = clean(minInput.getAttribute('min'));
    const MAX = clean(minInput.getAttribute('max'));

    function getAppliedValuesFromURL() {
      const params = new URLSearchParams(window.location.search);

      const minParam = minInput.getAttribute('name');
      const maxParam = maxInput.getAttribute('name');

      const urlMin = params.get(minParam);
      const urlMax = params.get(maxParam);

      return {
        lo: urlMin !== null ? clean(urlMin) : MIN,
        hi: urlMax !== null ? clean(urlMax) : MAX,
      };
    }

    function updateTrack(lo, hi) {
      const inputs = getInputs();

      if (lo === undefined) {
        lo = clean(inputs.min.value);
        hi = clean(inputs.max.value);
      }

      if (isNaN(lo)) lo = MIN;
      if (isNaN(hi)) hi = MAX;

      lo = Math.max(MIN, Math.min(lo, MAX));
      hi = Math.max(MIN, Math.min(hi, MAX));

      if (lo > hi - 1) {
        if (document.activeElement === inputs.min) {
          lo = Math.max(MIN, hi - 1);
          inputs.min.value = lo;
        } else {
          hi = Math.min(MAX, lo + 1);
          inputs.max.value = hi;
        }
      }

      const pct = (v) => ((v - MIN) / (MAX - MIN)) * 100;

      slider.style.setProperty('--range-left', pct(lo) + '%');
      slider.style.setProperty('--range-width', (pct(hi) - pct(lo)) + '%');

      if (display) {
        display.textContent = fmt(lo, SYM) + ' — ' + fmt(hi, SYM);
      }
    }

    const minClone = minInput.cloneNode(true);
    const maxClone = maxInput.cloneNode(true);

    minInput.replaceWith(minClone);
    maxInput.replaceWith(maxClone);

    const freshMin = slider.querySelector('input:first-of-type');
    const freshMax = slider.querySelector('input:last-of-type');

    freshMin.addEventListener('input', () => updateTrack());
    freshMax.addEventListener('input', () => updateTrack());

    freshMin.addEventListener('change', () => updateTrack());
    freshMax.addEventListener('change', () => updateTrack());

    const { lo, hi } = getAppliedValuesFromURL();

    freshMin.value = lo;
    freshMax.value = hi;

    updateTrack(lo, hi);
  });
}

initPriceRangeSlider();